// AUTHENTICATION GUARD
export const META_ALLOW_ANONYMOUS = "META_ALLOW_ANONYMOUS"; // allow auth AND non auth user to see the page
export const META_FORCE_ANONYMOUS = "META_FORCE_ANONYMOUS"; // ONLY allow non auth user to see the page
// HTML TITLE GUARD
export const META_HTML_TITLE = "META_HTML_TITLE"; // replace HTML title with the translated value of this meta
// ANALYTICS GUARD
export const META_NO_ANALYTICS_CONSENT = "META_NO_ANALYTICS_CONSENT"; // disable analytics consent popup for this page

// ROUTING META
export const META_HEADER_TITLE = "META_HEADER_TITLE"; // allow for the display of a title in a page
export const META_LAYOUT = "META_LAYOUT"; // choose layout for this route
export const META_HIDE_HEADER = "META_HIDE_HEADER"; // hide header for some layouts
export const META_SHOW_SUBHEADER = "META_SHOW_SUBHEADER"; // show subheader for some layouts
export const META_HIDE_FOOTER = "META_HIDE_FOOTER"; // hide footer for some layouts
export const META_BACK_ROUTE = "META_BACK_ROUTE"; // allow layouts to navigate to the backBtn route
export const META_FALLBACK_ROUTE = "META_FALLBACK_ROUTE"; // allow layouts to navigate to the backBtn route if there's no history
export const META_SCROLL_SAVE_POSITION = "META_SCROLL_SAVE_POSITION"; // save last scroll position
export const META_FULL_WIDTH = "META_FULL_WIDTH"; // ask an ancestor to be in full width mode
export const META_NO_SAVE_HISTORY = "META_NO_SAVE_HISTORY"; // don't save history for this route
